import { useState } from 'react';
import { ButtonLockup, Modal, Text } from '@stitch-fix/mode-react';
const DEFAULT_ERROR_MESSAGE = "Something didn't work with that photo. Please try a different one.";
const PhotoUploadErrorModal = ({
  onDismiss,
  onPhotoUpload,
  errorMessage
}: {
  onPhotoUpload: () => void;
  errorMessage?: string;
  onDismiss?: () => void;
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const handleClose = () => {
    setIsOpen(false);
    onDismiss?.();
  };
  return <Modal isOpen={isOpen} heading="Let's try that again" variant="slide-up-small" footer={<ButtonLockup primary={{
    children: 'Select a new photo',
    variant: 'filled-statement',
    onClick: () => {
      setIsOpen(false);
      onPhotoUpload();
    }
  }} secondary={{
    children: 'Cancel',
    onClick: handleClose
  }} />}>
      <Text mt={1} setting="body-medium">
        {errorMessage ?? DEFAULT_ERROR_MESSAGE}
      </Text>
    </Modal>;
};
export default PhotoUploadErrorModal;